import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect } from "react";
import { Forms } from "..";
import { Loading } from "../../../common/components/Loading";
import { DataRequestDetail } from "../../../common/models";
import { NetworkRequestState } from "../../../common/models/NetworkRequest";
import { Error as RequestsError } from "../../copy/requests";
import { Error } from "../Error";

type EditDataRequestDialogProps = {
  open: boolean;
  request: DataRequestDetail;
  onClose: () => void;
  onDone: () => void;
  updateRequestState: NetworkRequestState;
  handleSubmit: (values: any) => void;
};

export const EditDataRequestDialog = ({
  open,
  request,
  onClose,
  onDone,
  updateRequestState,
  handleSubmit,
}: EditDataRequestDialogProps) => {
  // auto-close dialog on success
  useEffect(() => {
    if (updateRequestState.success) {
      onDone();
    }
  }, [updateRequestState.success, onDone]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={onClose}
      aria-labelledby="update-request-dialog-title"
    >
      <DialogTitle id="update-request-dialog-title">Edit Request</DialogTitle>

      {updateRequestState.running && (
        <DialogContent>
          <Loading />
        </DialogContent>
      )}

      {updateRequestState.error && (
        <>
          <DialogContent>
            <Error message={updateRequestState.errorMessage || RequestsError.UpdateRequest} />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </>
      )}

      {!updateRequestState.started && (
        <Forms.EditDataRequest onSubmit={handleSubmit} onClose={onClose} request={request} />
      )}
    </Dialog>
  );
};
